import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { VueEditor } from 'vue2-editor'
import codes from '@/f1/codes';
import { api } from '@/f1/service';

const default_model = () => ({ is_alive: true });

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  removed: {
    EN : `removed`,
    KO : `삭제되었습니다`,
  },
};

export default {
  components: { VueEditor, cSwitch, vSelect },
  data : () => ({
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      allowed: false,
      codes
  }),
  computed: {
    i18n_data() { return _i18n_data },
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'faq', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'faq', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.board.faq.delete(this.model.id);
        this.$parent.$emit('refresh'); this.$toastr.s(this.i18n_data['removed'][this.i18n]); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.list() },
    list() { this.$router.push({ name: 'faq'}); },
    async save() {
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content required.'); }
      try {
        if(this.model.id) { await api.board.faq.update(this.model.id, this.model); }
        else { this.model.id = +(await api.board.faq.write(this.model)); }
        this.$toastr.s('Done.'); this.$parent.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] faq.detail', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      // try { this.model = Object.assign({}, this.model, await api.board.faq.get(id)); }
      try { let rs = await api.board.Board_Call('faq', 'detail', { id : id }); console.log(rs); this.model = rs.body }
      catch(e) { this.$toastr.e(e.data ? e.data.message : e.status); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('[vue] faq.detail', 'created'); },
  destroyed() { console.log('[vue] faq.detail', 'destroyed'); },
  mounted() {
    console.log('[vue] faq.detail', 'mounted');
    this.get(this.$route.params);
  },
}
